import type { AnalysisResult } from '../domain/models';

export type ImportProgress = {
  stage: string;
  progress: number;
};

type WorkerMessage =
  | { id: string; type: 'progress'; stage: string; progress: number }
  | { id: string; type: 'complete'; result: AnalysisResult }
  | { id: string; type: 'error'; message: string };

export async function parseTimelineFile(file: File, onProgress: (progress: ImportProgress) => void): Promise<AnalysisResult> {
  const text = await file.text();
  return parseTimelineText(text, file.name, file.size, onProgress);
}

export function parseTimelineText(
  text: string,
  fileName: string,
  fileSize: number,
  onProgress: (progress: ImportProgress) => void,
): Promise<AnalysisResult> {
  const worker = new Worker(new URL('./parser.worker.ts', import.meta.url), { type: 'module' });
  const id = crypto.randomUUID();

  return new Promise((resolve, reject) => {
    const cleanup = () => worker.terminate();

    worker.onmessage = (event: MessageEvent<WorkerMessage>) => {
      if (event.data.id !== id) return;
      if (event.data.type === 'progress') {
        onProgress({ stage: event.data.stage, progress: event.data.progress });
      }
      if (event.data.type === 'complete') {
        onProgress({ stage: '完了', progress: 1 });
        cleanup();
        resolve(event.data.result);
      }
      if (event.data.type === 'error') {
        cleanup();
        reject(new Error(event.data.message));
      }
    };

    worker.onerror = (error) => {
      cleanup();
      reject(new Error(error.message || 'Worker の起動に失敗しました'));
    };

    worker.postMessage({ id, fileName, fileSize, text });
  });
}
